import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

// Services
import { DialogsService } from '@toro/common/shared/services/dialogs.service';

// Interfaces
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';

// Components
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { StockCardsComponent } from '../../../partials/stock-cards/stock-cards.component';

// RX
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { GroupmentCardModalComponent } from '../../../partials/stock/dialogs/groupment-card-modal/groupment-card-modal.component';

// Constants
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { STOCK_LOGO_PLACEHOLDER } from '@toro/common/shared/resources/consts';
import { TrackingsService } from '../../../services/tracking.service';

@AutoUnsubscribe()
@Component({
    selector: 'grouped-card',
    templateUrl: './grouped-card.component.html',
    styleUrls: ["./grouped-card.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class GroupedCardComponent extends StockCardsComponent implements OnDestroy  {

    @ViewChild('elementCard', {static: true}) public elementCard: ElementRef;
    @Input() stockDetails: any;
    public symbol: string;
    public sideText: string;
    public symbolLogo: string;
    public symbolName: string;
    public symbolQuote: number = 0;
    public pending: boolean = false;
    public instrument: any = null;
    public variation: number = null;
    public valueVariation: string;
    public investedValue: number = 0;
    public resultValue: number = 0;

    private quoteSubscription: Subscription;
    private instrumentSubscription: Subscription;

    constructor(
        protected router: Router,
        protected dialogServices: DialogsService,
        protected store: Store<AppState>,
        protected changeDetectorRef: ChangeDetectorRef,
        public toastrService: ToastrService,
        private tracking: TrackingsService
    ) {
        super(router, dialogServices, store, changeDetectorRef);
        this.dispatchs();
    }

    public dispatchs() {
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbol });
    }

    public ngOnInit() {
        this.symbol = this.stockDetails.symbol;
        this.sideTitle();

        this.bindQuoteSubscription();
        this.bindInstrumentSubscription();
    }


    public sideTitle() {
        if(this.stockDetails.twoSideOperation) {
            this.sideText = '';
            return;
        }
        switch (this.stockDetails.side) {
            case OrderSideEnum.Compra:
                this.sideText = 'COMPRADO'; break;
            case OrderSideEnum.Venda:
                this.sideText = 'VENDIDO'; break;
            default:
                this.sideText = '';break;
        }
    }

    public get getResult() {
        return (this.symbolQuote - this.stockDetails.averagePrice) * this.stockDetails.total;
    }

    public bindInstrumentSubscription = () => {
        this.instrumentSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.instruments)
            .pipe(
                filter((item) => this.stockDetails && item[this.symbol] ? true : false),
                map((item) => item[this.symbol]),
                first()
            )
            .subscribe((instrument) => {
                this.instrument = instrument;
                this.symbolLogo = this.instrument.logo.content;
                this.symbolName = this.instrument.descriptionStock;
            });
    }

    public bindQuoteSubscription = () => {
        this.quoteSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((item) => this.stockDetails && item[this.symbol]),
                map((item) => item[this.symbol])    
            )
            .subscribe((data) => {
                this.symbolQuote = data.PriceLastTrade || data.OpeningPrice || data.ClosingPricePreviousDay;
                this.variation = Math.abs(data.Variation);
                
                if (data.Variation === 0) {
                    this.valueVariation = 'normal';
                } else {
                    this.valueVariation = data.Variation > 0 ? 'high' : 'low';
                }
            });
    }

    private sendMetrics() {
        this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
          "Product Area Origin": 'Meus investimentos',
          "Element": 'Botão ver posições',
          "Group": 'Lista meus investimentos',
          'Scenario': 'Grupo de ativos',
          'Time Responsável': 'Roebling',
        });
      }

    public openModalGroup(){
        this.sendMetrics();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.dialogsService.showComponnent(GroupmentCardModalComponent, this.stockDetails)
    }

    public noLogoHandler(event) {
        this.symbolLogo = STOCK_LOGO_PLACEHOLDER;
    }

    public ngOnDestroy() {}
}
